import React from "react";

import './loanSteps.css'
const steps = [
    {
        step: "STEP 1",
        title: "Check Your Eligibility",
        desc: "Fill out a quick form & get instant pre-approval.",
        imgAlt: "Eligibility Icon",
        imgSrc: "/assets/img/phoneup.png", // Add image path here
        highlight: "Check Your Eligibility",
    },
    {
        step: "STEP 2",
        title: "Compare & Choose",
        desc: "Get personalized loan offers from top lenders.",
        imgAlt: "Compare Icon",
        imgSrc: "/assets/img/loanStepImg.png", // Add image path here
        highlight: "Compare & Choose",
    },
    {
        step: "STEP 3",
        title: "Get Your Loan",
        desc: "Submit documents, get approved, and receive funds in 24–48 hours.",
        imgAlt: "Loan Icon",
        imgSrc: "", // Add image path here
        highlight: "Get Your Loan",
    },
];

export default function StepsSection() {
    return (
        <section
            className=" w-[91vw] sm:w-screen bg-cover loanStep-mobile-height max-h-[980px] sm:max-h-[1020px]  overflow-hidden bg-center px-4 py-10 md:py-20 bg-img-steps mt-5 rounded-3xl  sm:max-w-6xl"

        >
            <div className="text-center font-bomstad-semibold text-[#12F280] text-xl md:text-5xl  mb-8">
                Getting a <span className="text-green-400">Personal Loan</span> <br /> Is as{" "}
                <span className="text-white">Easy </span>{" "}
                <span className="text-green-400"> as 1–2–3!</span>
            </div>

            <div className="flex flex-col items-center  overflow-hidden  gap-4 md:gap-10 md:max-w-2xl mx-auto">
                {steps.map((step, index) => (
                    <div
                        key={index}
                        className=" relative w-full overflow-hidden  max-w-sm h-[294px] bg-gradient-to-br from-[#1c1c1c1a] to-[#17161680] border-1 border-gray-700 rounded-2xl z-0 text-white p-5 flex flex-col items-start gap-3 backdrop-blur-sm"
                    >
                        {/* number */}
                        <div className="font-bruno-ace absolute top-[-10%] left-[-20%] text-[160px] font-bold text-black/50 -z-10">0{index+1}</div>
                        <div className=" text-md font-atkinson tracking-[3px] text-gray-300 ">
                            {step.step}
                        </div>
                        <div className="text-[16px] leading-tight font-atkinson ">
                            <span className="text-green-400 font-medium">
                                {step.highlight}
                            </span>
                            —{step.desc}
                        </div>
                       <img
                                src={step.imgSrc}
                                alt={step.imgAlt}
                                className="absolute left-[7.5%] bottom-[-24%] w-[85%] "
                            />
                      
                        

                        
                    </div>
                ))}
              
               
            </div>
        </section>
    );
}
